module.exports = __webpack_public_path__ + "img/CRC2_CD4Tconv.04185ec0.png";